/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Clips_CatInputs */

const en_road_dude_clips_cat = /** @type {(inputs: Road_Dude_Clips_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The cat owns the pond`)
};

const zh_road_dude_clips_cat = /** @type {(inputs: Road_Dude_Clips_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这片池塘归猫咪管`)
};

/**
* | output |
* | --- |
* | "The cat owns the pond" |
*
* @param {Road_Dude_Clips_CatInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_clips_cat = /** @type {((inputs?: Road_Dude_Clips_CatInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Clips_CatInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_clips_cat(inputs)
	return zh_road_dude_clips_cat(inputs)
});
export { road_dude_clips_cat as "road_dude.clips.cat" }